// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { InvalidLink } from './invalid-link'

const COMPONENT_ID = 'invalidLink'

export const showInvalidLinkDialog = (
  props: Omit<Parameters<typeof InvalidLink>[0], 'isOpen'>,
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: InvalidLink,
  },
}
